/**
 * Animations Module
 * Handles GSAP animations and scroll-triggered effects
 */

import { $, exists } from "../utils/dom.js";

export const initHomeHeroParallax = () => {
  if (window.innerWidth >= 1024) {
    if (exists(".hero--home")) {
      gsap.to(".hero--home .hero__image img", {
        scrollTrigger: {
          trigger: ".hero--home",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
        // transform: "translateX(22%) translateY(-45%) rotate(15deg)",
        transform: "translateX(-6%)",
      });
    }
  }
};

export const initMapSection = () => {
  if (window.innerWidth < 1024) {
    if (exists(".map")) {
      gsap.to(".map img", {
        scrollTrigger: {
          trigger: ".map",
          // start: "top+=25 top",
          start: "top+=150 center",
          end: "center+=100 center",
          scrub: true,
        },
        transform: "translateX(-50%)",
      });
    }
  }
};

export const initSideContentSticky = () => {
  const sections = document.querySelectorAll(".side-content-sticky");
  if (!sections.length) {
    return;
  }

  window.addEventListener("scroll", () => {
    sections.forEach((section) => {
      const items = section.querySelectorAll(
        ".side-content-sticky__content__item",
      );
      const imageContainer = section.querySelector(
        ".side-content-sticky__image",
      );

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const stickyItemValue = item.getAttribute("data-sticky-item");
        const stickyImage = imageContainer
          ? imageContainer.querySelector(
              `img[data-sticky-item="${stickyItemValue}"]`,
            )
          : null;

        if (rect.top <= window.innerHeight / 3) {
          if (stickyImage) {
            stickyImage.classList.add("active");
          }
        } else {
          if (stickyImage) {
            stickyImage.classList.remove("active");
          }
        }
      });
    });
  });
};

export const initMediaImageTextScroll = () => {
  if (exists(".media-image-text-scroll")) {
    const initializeScroll = () => {
      const section = document.querySelector(".media-image-text-scroll");
      const backgroundImage = getComputedStyle(section).backgroundImage;

      const img = new Image();
      img.src = backgroundImage.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");

      img.onload = function () {
        const useAuto = img.width >= window.innerWidth;

        const updateBackgroundSize = (scrollProgress) => {
          if (useAuto) {
            const heightSize = 100 + scrollProgress * 10;
            section.style.backgroundSize = `${heightSize}% auto`;
          } else {
            const widthSize = 100 + scrollProgress * 10;
            section.style.backgroundSize = `${widthSize}% auto`;
          }
        };

        const rect = section.getBoundingClientRect();
        const scrollProgress =
          (window.innerHeight - rect.top) /
          (section.offsetHeight - window.innerHeight);
        updateBackgroundSize(scrollProgress);

        window.removeEventListener("scroll", section.scrollHandler);

        section.scrollHandler = () => {
          const rect = section.getBoundingClientRect();
          const scrollProgress =
            (window.innerHeight - rect.top) /
            (section.offsetHeight - window.innerHeight);
          updateBackgroundSize(scrollProgress);
        };

        window.addEventListener("scroll", section.scrollHandler);
      };
    };

    initializeScroll();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initializeScroll, 250);
    });
  }
};
